
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace-partner",
      function () {
        return require("private-next-pages/marketplace-partner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace-partner"])
      });
    }
  